module.exports = __webpack_public_path__ + "static/media/action-rename-plan.8efb7ef1.svg";